import { render, staticRenderFns } from "./Loquii.vue?vue&type=template&id=ed75e3d4"
import script from "./Loquii.vue?vue&type=script&lang=js"
export * from "./Loquii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports